export default {
  getAgreementFieldByName: ({ list }) => (field, name) => {
    const entity = list.find(el => el.name === name);
    return entity ? entity[field] : '';
  },
};
